<template>
  <!-- Content -->
  <d-row>
    <d-col cols="12" class="col-md">
      <d-card class="mb-4 card-small">
        <!-- Card Header -->
        <d-card-header class="border-bottom">
          <d-row class="align-items-center">
            <d-col cols="12" lg="6">
              <h6 class="m-0">Dados cadastrais</h6>
            </d-col>
          </d-row>
        </d-card-header>

        <d-list-group flush>
          <d-list-group-item class="p-3">
            <d-row>
              <d-col>
                <magazine-form ref="magazineFormRef" />
              </d-col>
            </d-row>
          </d-list-group-item>
        </d-list-group>
      </d-card>
    </d-col>
    <!-- Sidebar Widgets -->
    <d-col lg="auto" sm="12" class="position-relative sidebar-publish">
      <d-card class="mb-3 card-small position-sticky">
        <d-card-header class="border-bottom d-flex justify-content-between align-items-center">
          <h6 class="m-0">Publicação</h6>
          <d-button @click="draft" type="button" class="btn-outline-accent col-5">Rascunho</d-button>
        </d-card-header>

        <d-card-body class="px-0">
          <d-list-group flush>
            <d-list-group-item class="px-3 py-0 dates">
              <div class="pb-1">Status: <span>{{ status }}</span></div>
              <div class="pb-1">Criado em: <span>{{ magazine.created_at }}</span></div>
              <div class="pb-1">
                Publicado em:
                <template v-if="editPublishDate">
                  <datepicker
                    class="mb-2"
                    type="datetime"
                    format="DD/MM/YYYY | HH:mm"
                    :model.sync="dateTime"
                  />
                </template>
                <span v-else>{{ magazine.f_published_date }}</span>
                <a class="edit" @click="togglePublishDate">
                  <template v-if="editPublishDate">Cancelar</template>
                  <template v-else>Editar</template>
                </a>
                <d-button v-if="editPublishDate" @click="savePublish" type="button" class="py-0 ml-2 btn btn-outline-info btn-primary btn-sm">Ok</d-button>
              </div>
            </d-list-group-item>
          </d-list-group>
        </d-card-body>

        <d-card-footer class="border-top d-flex justify-content-around">
         <d-button
            @click="publish"
            type="button"
            class="btn-primary mb-xl-0 col-5 col-xl-5"
            v-if="magazine.status_id !== 2"
          >Publicar</d-button>
          <d-button
            @click="save"
            type="button"
            class="btn-primary mb-xl-0 col-5 col-xl-5"
            v-else
          >Salvar</d-button>
          <router-link
            class="text-white btn-secondary btn col-xl-5 col-5"
            :to="{ name: 'admin-magazine-list', params: { page: 1 } }"
          >Cancelar</router-link>
        </d-card-footer>
      </d-card>
    </d-col>
  </d-row>
</template>

<script>
import Events from '_utils/events';
import { cloneDeep, getDateByFormatedDate } from '_utils';
import Datepicker from '_shared/Datepicker.vue';
import MagazineForm from './MagazineForm.vue';
import { MODEL, _LOAD_MODEL_ } from './MagazineModel';

export default {
  name: 'magazine-page',
  components: {
    MagazineForm,
    Datepicker,
  },
  computed: {
    magazine() {
      const { magazineEdit } = this.$store.state.magazine;
      if (magazineEdit) {
        Events.$emit(_LOAD_MODEL_, magazineEdit);
        return magazineEdit;
      }
      return cloneDeep(MODEL);
    },
    status() {
      if (this.magazine.status_id === 2) {
        const date = getDateByFormatedDate(this.magazine.published_date);
        const now = new Date();
        if (date > now) {
          return 'Agendado';
        }
      }
      return this.magazine.status.name;
    },
  },
  data() {
    return {
      editPublishDate: false,
      dateTime: null,
    };
  },
  methods: {
    draft() {
      this.$refs.magazineFormRef.draft();
    },
    save() {
      this.$refs.magazineFormRef.save();
    },
    publish() {
      this.$refs.magazineFormRef.publish();
    },
    togglePublishDate() {
      this.dateTime = getDateByFormatedDate(this.magazine.published_date);
      this.editPublishDate = !this.editPublishDate;
    },
    savePublish() {
      this.magazine.published_date = this.dateTime;
      Events.$emit(_LOAD_MODEL_, this.magazine);
      this.$refs.magazineFormRef.save();
      this.editPublishDate = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.sidebar-publish {
  .card-small {
    min-width: 290px;
  }
  .position-sticky {
    top: 80px;
  }
  .dates {
    span {
      font-size: 12px;
      font-weight: bold;
    }
    a {
      margin-left: 5px;
      color: $primary;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>
